import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import Modal from "@/components/Modal";

export default function BarcodeScanner({ onDetected, onClose }) {
  const ref = useRef(null);
  useEffect(() => {
    let stopped = false;
    const scanner = new Html5Qrcode("pos-scanner-region");
    ref.current = scanner;
    scanner.start(
      { facingMode: "environment" },
      { fps: 10, qrbox: { width: 260, height: 160 } },
      (text) => { if (!stopped) { stopped = true; onDetected(text); } },
      () => {}
    ).catch(() => {});
    return () => { try { scanner.stop().then(() => scanner.clear()).catch(() => {}); } catch (e) { /* ignore */ } };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal open={true} onClose={onClose} title="Scanner un code-barres" testId="scanner-modal"
      footer={<button className="btn-outline" onClick={onClose} data-testid="scanner-close-btn">Fermer</button>}>
      <div id="pos-scanner-region" className="w-full rounded-lg overflow-hidden bg-black/5 min-h-[240px]" data-testid="scanner-region" />
      <p className="text-xs text-[#64748B] mt-2">Autorisez l'accès à la caméra, puis présentez le code-barres. Sur un ordinateur sans caméra, saisissez le code à la main dans le champ.</p>
    </Modal>
  );
}
